import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/target_group.types';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useDiscounts} from './useDiscounts';

export const useShowCampaignPhonePopup = () => {
  const {data: discountData} = useDiscounts();
  const {targetGroup} = useSelectedTargetGroup();

  if (!discountData || !discountData.discount) return false;

  if (targetGroup === TargetGroup.FEMALE) {
    return discountData.discount.femaleTopBanner.showAppStoreLinkCta;
  } else {
    return discountData.discount.maleTopBanner.showAppStoreLinkCta;
  }
};
